export default "__VITE_ASSET__BMEkOVWC__"